import { Camera, ImageOff } from 'lucide-react'

interface HeroImageEditableProps {
  url: string | null
  alt: string | null
  onReplace: () => void
}

export function HeroImageEditable({ url, alt, onReplace }: HeroImageEditableProps) {
  return (
    <div className="relative group cursor-pointer rounded-lg overflow-hidden" onClick={onReplace}>
      {url ? (
        <div className="aspect-video">
          <img
            src={url}
            alt={alt ?? 'Hero image'}
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <div className="aspect-video bg-muted flex flex-col items-center justify-center gap-2">
          <ImageOff className="size-12 text-muted-foreground/40" />
          <span className="text-sm text-muted-foreground">No hero image</span>
          <span className="text-xs text-muted-foreground/60">Click to add</span>
        </div>
      )}

      {/* Hover overlay */}
      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center flex-col gap-1">
        <Camera className="size-8 text-white" />
        <span className="text-sm font-medium text-white">Replace Image</span>
      </div>
    </div>
  )
}
